import { render, staticRenderFns } from "./ExchangeRemoteServicePage.vue?vue&type=template&id=0e69e596&scoped=true"
import script from "./ExchangeRemoteServicePage.vue?vue&type=script&lang=js"
export * from "./ExchangeRemoteServicePage.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRemoteServicePage.vue?vue&type=style&index=0&id=0e69e596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e69e596",
  null
  
)

export default component.exports